import api from './api';

class UploadService {
  async uploadWorkplaceQrLogo(file) {
    const formData = new FormData();
    formData.append('files[]', file);

    const response = await api.post('/uploads/images', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    const firstImage = response?.data?.images?.find((image) => image?.ok);
    const logoUrl = firstImage?.urls?.mobile || firstImage?.urls?.thumb;

    if (!logoUrl) {
      throw new Error('Upload response does not contain image URL.');
    }

    return logoUrl;
  }
}

export default new UploadService();
